"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieListener = void 0;
const cookie = __importStar(require("cookie"));
const INTERVAL_MS = 200;
class CookieListener {
    constructor() {
        this.listeners = {};
        this.eventLoopInterval = null;
    }
    startEventLoop() {
        if (this.eventLoopInterval) {
            return;
        }
        let cookiesStr = document.cookie;
        let parsedCookies = cookie.parse(document.cookie);
        this.eventLoopInterval = window.setInterval(() => {
            if (cookiesStr !== document.cookie) {
                const newParsedCookies = cookie.parse(document.cookie);
                this.handleChange(parsedCookies, newParsedCookies);
                cookiesStr = document.cookie;
                parsedCookies = newParsedCookies;
            }
        }, INTERVAL_MS);
    }
    stopEventLoop() {
        if (this.eventLoopInterval) {
            clearInterval(this.eventLoopInterval);
            this.eventLoopInterval = null;
        }
    }
    handleChange(oldCookies, newCookies) {
        Object.keys(this.listeners).forEach((cookieName) => {
            if (oldCookies[cookieName] !== newCookies[cookieName]) {
                this.listeners[cookieName].forEach((handler) => handler(newCookies));
            }
        });
    }
    onChange(cookieName, handler) {
        if (!this.listeners[cookieName]) {
            this.listeners[cookieName] = [];
        }
        this.listeners[cookieName].push(handler);
        this.startEventLoop();
        return () => {
            this.listeners[cookieName] = this.listeners[cookieName].filter((h) => h !== handler);
            if (this.listeners[cookieName].length === 0) {
                delete this.listeners[cookieName];
                if (Object.keys(this.listeners).length === 0) {
                    this.stopEventLoop();
                }
            }
        };
    }
}
exports.CookieListener = CookieListener;
exports.default = new CookieListener();
